import { Component, OnDestroy } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { startWith } from 'rxjs/operators';
// import { clearInterval } from 'timers';

@Component({
	selector: 'app-ngbd-modal-content',
	template: `
	  <div class="modal-header">
		<h4 id="logoutHeader" class="modal-title">
			Session Expiration
		</h4>
		<button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cancel')">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
	  	<h5 class="modal-title">
	  		Your session will terminate in {{ secondsRemaining$ | async }} seconds.
  		</h5>
		<p>Would you like to remain logged in?</p>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="activeModal.close('StayloggedIn')">Remain Logged In</button>
		<button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close')">Logout Now</button>
	  </div>
	`
})
export class NgbdModalContentComponent implements OnDestroy {

	secondsRemaining$: Observable<number>;
	intervalID: number;
	constructor(public activeModal: NgbActiveModal, private http: HttpClient) {
		let Ttl_seconds = 60;
		this.GetSessionTimeoutInSec().then(resp => {
			if (resp > 60) {
				activeModal.close('StayloggedIn')
			} else {
				Ttl_seconds = resp;
			}
		}).catch(resp => {
			//Leave the count at 60
		});

		this.secondsRemaining$ = new Observable<number>(observer => {
			let seconds = Ttl_seconds;
			this.intervalID = window.setInterval(() => {
				seconds -= 1;
				//If it's counting down (not 60 or 0s left) then make another request
				//to see if we can close because they have another window active elsewhere.
				if ((seconds % 20 == 0) && (seconds !== 60 && seconds > 0)) {
					//console.log("10s elapsed polling for server side timeout");
					this.GetSessionTimeoutInSec().then(resp => {
						if (resp > 60) {
							//console.log("Response from server > 60s, killing obs and closing modal", resp);
							observer.complete();
							activeModal.close('StayloggedIn')
						}
					}).catch(resp => {
						activeModal.close('Timeout');
					});
				}
				if (seconds > 0) {
					observer.next(seconds);
				} else {
					window.clearInterval(this.intervalID);
					observer.complete();
					if (activeModal) {
						activeModal.close('Timeout');
					}
				}
			}, 1000);
		}).pipe(startWith(Ttl_seconds));
	}

	ngOnDestroy() {
		window.clearInterval(this.intervalID);
	}

	/**
 * Retrieves the server side time left in MS.
 * @returns Seconds left in the server side timeout
 */
	private GetSessionTimeoutInSec(): Promise<number> {
		let url = "api/auth/GetTimeout/";
		return this.http.get<number>(url).toPromise<number>();
	}
}
